import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { fg } from '@atlaskit/platform-feature-flags';
import { isGQLGatewayError, isGQLUnderlyingServiceError } from '../graphql/types';
import { useMetricsContext } from '../../context';
import { getExtensionListQuery, getExtensionListQueryOld } from './lib/queries';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { OPERATIONAL_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { FORGE_UI_ANALYTICS_CHANNEL } from '../../analytics';
import { createAtlAttributionHeader } from '../../utils';
export var createExtensionListQueryOptions = function createExtensionListQueryOptions(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale) {
  var ssr = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  var variables = filter ? {
    contextIds: contextIds,
    locale: locale,
    filter: filter
  } : {
    contextIds: contextIds,
    locale: locale,
    type: extensionType
  };
  var query = filter ? getExtensionListQuery(expandAppOwner, dataClassificationTagIds) : getExtensionListQueryOld(expandAppOwner, undefined, dataClassificationTagIds);
  var headers = {};
  // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
  if (fg('forge-ui-include-atl-attribution-header')) {
    headers['atl-attribution'] = createAtlAttributionHeader(contextIds.sort().join());
  }

  // In SSR mode render and fetch is one-pass we can't do cache-and-network
  if (ssr && (queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy) === 'cache-and-network') {
    queryOptions.fetchPolicy = 'cache-first';
  }
  return _objectSpread(_objectSpread({
    variables: variables
  }, queryOptions), {}, {
    query: query,
    client: client,
    /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */
    errorPolicy: 'all',
    context: {
      headers: headers
    }
  });
};
export var getExtensionsFromGQLResult = function getExtensionsFromGQLResult(_ref) {
  var loading = _ref.loading,
    data = _ref.data;
  if (!loading && data && data.extensionContexts && data.extensionContexts[0]) {
    if ('extensions' in data.extensionContexts[0]) {
      var _data$extensionContex;
      return (_data$extensionContex = data.extensionContexts[0].extensions) !== null && _data$extensionContex !== void 0 ? _data$extensionContex : null;
    } else if ('extensionsByType' in data.extensionContexts[0]) {
      var _data$extensionContex2;
      return (_data$extensionContex2 = data.extensionContexts[0].extensionsByType) !== null && _data$extensionContex2 !== void 0 ? _data$extensionContex2 : null;
    }
  }
  return null;
};
export var getExtensionListForSSR = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var client, contextIds, extensionType, filter, queryOptions, expandAppOwner, dataClassificationTagIds, locale, queryFn, requestOptions, query, _yield$queryFn, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          client = _ref2.client, contextIds = _ref2.contextIds, extensionType = _ref2.type, filter = _ref2.filter, queryOptions = _ref2.queryOptions, expandAppOwner = _ref2.expandAppOwner, dataClassificationTagIds = _ref2.dataClassificationTagIds, locale = _ref2.locale, queryFn = _ref2.queryFn;
          if (queryFn) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", null);
        case 3:
          requestOptions = createExtensionListQueryOptions(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale, true);
          query = filter ? getExtensionListQuery(expandAppOwner) : getExtensionListQueryOld(expandAppOwner);
          requestOptions.query = requestOptions.query || query;
          _context.next = 8;
          return queryFn(requestOptions);
        case 8:
          _yield$queryFn = _context.sent;
          data = _yield$queryFn.data;
          if (data) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", null);
        case 12:
          return _context.abrupt("return", getExtensionsFromGQLResult({
            loading: false,
            data: data
          }));
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getExtensionListForSSR(_x) {
    return _ref3.apply(this, arguments);
  };
}();
export var useExtensionList = function useExtensionList(_ref4) {
  var contextIds = _ref4.contextIds,
    extensionType = _ref4.type,
    filter = _ref4.filter,
    client = _ref4.client,
    queryOptions = _ref4.queryOptions,
    expandAppOwner = _ref4.expandAppOwner,
    dataClassificationTagIds = _ref4.dataClassificationTagIds,
    locale = _ref4.locale;
  var requestOptions = createExtensionListQueryOptions(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale);
  var query = filter ? getExtensionListQuery(expandAppOwner) : getExtensionListQueryOld(expandAppOwner);
  var _useQuery = useQuery(requestOptions.query || query, requestOptions),
    error = _useQuery.error,
    loading = _useQuery.loading,
    data = _useQuery.data;
  var extensions = getExtensionsFromGQLResult({
    loading: loading,
    data: data
  });
  var _useMetricsContext = useMetricsContext(),
    page = _useMetricsContext.page;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  useEffect(function () {
    if (extensions) {
      createAnalyticsEvent({
        eventType: OPERATIONAL_EVENT_TYPE,
        data: {
          action: 'succeeded',
          actionSubject: 'forge.ui.webClient',
          source: page,
          tags: ['forge'],
          attributes: {
            target: 'useExtensionList'
          }
        }
      }).fire(FORGE_UI_ANALYTICS_CHANNEL);
    }
  }, [extensions, page, createAnalyticsEvent]);
  useEffect(function () {
    if (
    // if hydration of appOwners (non-critical data) fails but we still have the extensions,
    // we shouldn't count this as a bad event
    !extensions && error && error.graphQLErrors.length > 0) {
      var err = error.graphQLErrors.find(function (err) {
        return isGQLUnderlyingServiceError(err) || isGQLGatewayError(err);
      });
      createAnalyticsEvent({
        eventType: OPERATIONAL_EVENT_TYPE,
        data: {
          action: 'failed',
          actionSubject: 'forge.ui.webClient',
          source: page,
          tags: ['forge'],
          attributes: {
            target: 'useExtensionList',
            errorName: err ? isGQLUnderlyingServiceError(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
          }
        }
      }).fire(FORGE_UI_ANALYTICS_CHANNEL);
    }
  }, [extensions, error, page, createAnalyticsEvent]);
  return {
    error: error,
    extensions: extensions || [],
    loading: loading
  };
};